import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=4d6f9d3b&"
import script from "./ReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports